import {
  ADDRESS_LIST_MAX_FILE_SIZE,
  ADDRESS_LIST_ALLOWED_EXTENSIONS,
} from "@/features/dmManagement/types/constants";

/** 宛先リストファイル（CSV/Excel）のバリデーション。エラー時はメッセージを返し、正常時はnullを返す */
export const validateAddressListFile = (file: File): string | null => {
  const ext = file.name.split(".").pop()?.toLowerCase();
  if (!ext || !ADDRESS_LIST_ALLOWED_EXTENSIONS.includes(ext)) {
    return "CSV または Excel ファイルを選択してください";
  }

  if (file.size > ADDRESS_LIST_MAX_FILE_SIZE) {
    return "ファイルサイズは5MB以下にしてください";
  }

  return null;
};
